/** @file Tile height of a 30-degree iso grid for a tile width: round(tileW * tan 30 deg) (spec §5.10). */

/** tan(30 deg) = 1 / sqrt(3). */
const TAN_30 = 0.5773502691896257;

/** Math.max(1, Math.round(tileW * tan 30 deg)); 64 -> 37. The single copy every package imports (W2-24). */
export function isoTileHeight(tileW: number): number {
  return Math.max(1, Math.round(tileW * TAN_30));
}
